import React from 'react';
import { Helmet } from 'react-helmet-async';

const PaymentSuccess = () => {
  return (
    <>
      <Helmet>
        <title>Payment Successful - AI Music</title>
      </Helmet>

      <div className="text-center">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-slate-900 text-3xl font-semibold mb-2">
            Payment Successful!
          </h1>
          <p className="text-slate-600">
            Your subscription has been activated
          </p>
        </div>

        {/* Success Icon */}
        <div className="mb-6 flex justify-center">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-green-600"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {/* Success Message */}
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-800">
            Thank you for your purchase! Your account has been upgraded and you can now enjoy all the features of your new plan.
          </p>
        </div>

        {/* Back Button */}
        <button
          onClick={() => window.close()}
          className="w-full py-3 px-6 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200 font-medium"
        >
          Back to Canva
        </button>
      </div>
    </>
  );
};

export default PaymentSuccess;
